module.exports = __webpack_public_path__ + "static/media/leaderboardBackground.88103621.svg";